import {clsx} from 'clsx'
import type {ElementType} from 'react'

import styles from './blankslate.module.css'

type BlankslateProps = {
  as?: ElementType
  className?: string
  children?: React.ReactNode
} & React.HTMLAttributes<HTMLElement>

export const Blankslate = ({as: Component = 'div', className, children, ...props}: BlankslateProps) => (
  <Component className={clsx(styles.blankslateContainer, className)} {...props}>
    <div className={styles.blankslateContent}>{children}</div>
  </Component>
)
